import InputState from "../../engine/inputActions/InputState";
import { log } from "../../engine/logger/logger";
import { getDirectionFromVector } from "../../engine/space/directions";
import { openModal } from "../../ui/containers/Modal";
import { createElement } from "../../ui/ui";
import { Action, ActionSpeed, createAction } from "../actions/Action";
import { attackTowards, blockAttacks } from "../actions/ActionAttacks";
import { moveTowards, sprintTowards, wait } from "../actions/ActionMovement";
import { getActiveAttack } from "../actors/weaponHelper";
import { LookParticle } from "../anims/particles/LookParticle";
import { ParticleManager } from "../anims/particleSystem";
import { findActorForPosition, gameData } from "../GameManager";
import { CheckMovement } from "../map/Movement";
import { CheatModal } from "../ui/cheat/CheatModal";
import {
  getActorWeight,
  getWeightLevel,
  hasStrength,
  weightToActionSpeed,
} from "../items/formulas";
import { Encumbrance } from "../actors/Actor";

export const Commands: {
  [key: string]: (args?: any) => void | Action<any> | Action<any>[];
} = {
  cheat: () => {
    openModal(createElement(CheatModal, { x: 0, y: 0, w: 40, h: 20 }));
  },
  wait: () => {
    return createAction(wait, gameData.player, null);
  },
  move: (direction: { x: number; y: number }) => {
    const player = gameData.player;
    const dir = getDirectionFromVector(direction);
    const tile =
      gameData.current.tiles[player.x + player.y * gameData.current.width];

    if (dir && CheckMovement[dir](tile)) {
      const target = findActorForPosition(
        player.x + direction.x,
        player.y + direction.y
      );
      if (target) {
        const attack = getActiveAttack(gameData.player);
        if (gameData.player.stamina.current < attack.stamina) {
          log("Not enough stamina to attack");
        } else if (!hasStrength(gameData.player, attack)) {
          log("You are not strong enough to use this attack");
        } else {
          if (attack.blocks) {
            return createAction(
              blockAttacks,
              gameData.player,
              null,
              ActionSpeed.FAST
            );
          } else {
            return createAction(attackTowards, gameData.player, {
              dir,
            });
          }
        }
      } else {
        return createAction(
          moveTowards,
          gameData.player,
          {
            dir,
          },
          weightToActionSpeed(
            getWeightLevel(
              getActorWeight(gameData.player),
              gameData.player.attributes.weight
            )
          )
        );
      }
    } else {
      log("You cannot move or attack in that direction.");
    }
  },
  sprint: (direction: { x: number; y: number }) => {
    const player = gameData.player;
    const weightLevel = getWeightLevel(
      getActorWeight(player),
      player.attributes.weight
    );
    if (weightLevel === Encumbrance.HEAVY) {
      log("You cannot sprint while slow (75%+ carry load)");
      return;
    }

    if (
      (weightLevel === Encumbrance.LIGHT && 15 < player.stamina.current) ||
      (weightLevel === Encumbrance.MEDIUM && 30 < player.stamina.current)
    ) {
      const dir = getDirectionFromVector(direction);
      const tile =
        gameData.current.tiles[player.x + player.y * gameData.current.width];

      if (dir && CheckMovement[dir](tile)) {
        const target = findActorForPosition(
          player.x + direction.x,
          player.y + direction.y
        );
        if (target) {
          log("You cannot sprint directly into enemies.");
        } else {
          return createAction(sprintTowards, gameData.player, { dir });
        }
      }
    } else {
      log("Not enough stamina to sprint.");
    }
  },
  look: () => {
    if (gameData.looking) {
      InputState.popInputHandler();
      gameData.looking = false;
      gameData.targetFocus?.finish();
      gameData.targetFocus = null;
    } else {
      InputState.pushInputHandler(["base", "focusMove"]);
      gameData.looking = true;
      gameData.targetFocus = ParticleManager.createParticle(
        LookParticle,
        gameData.player.x,
        gameData.player.y
      );
    }
  },
  focusMove: (direction: { x: number; y: number }) => {
    if (gameData.targetFocus) {
      gameData.targetFocus.x += direction.x;
      gameData.targetFocus.y += direction.y;
    }
  },
};
